window.addEventListener("turbolinks:load", assignUnsavedEvents);

window.addEventListener("load", warn_unsaved);
window.addEventListener("turbolinks:load", warn_unsaved);

function assignUnsavedEvents() {
    let submittedForm = false;
    const beforeUnloadListener = (event) => {
        if (submittedForm) return;
        event.preventDefault();
        event.returnValue = "";
    };

    const body = document.querySelector(".lmu-klinikum");

    body.addEventListener("input", (event) => {
        if (event.target.value !== "" && !submittedForm) {
            addEventListener("beforeunload", beforeUnloadListener);
        } else {
            removeEventListener("beforeunload", beforeUnloadListener);
        }
    });

    document.addEventListener("submit", () => {
        submittedForm = true;
    });
}

function warn_unsaved() {
    document.addEventListener("input", () => {
        const add_contact_button = document.querySelector(".add_contact");
        if (add_contact_button) {
            add_contact_button.disabled = true;
            document.getElementById("disabled-label").classList.remove("hidden");
        }
    });
}
